import {
  axiosAdminInstance,
  misbarAdminInstance,
} from "api/services/axiosInstance";
import {
  ADMIN_URL,
  ADMIN_USER_URL,
  ORG_USER_URL,
  MARKETPLACE_URL,
  OFFER_URL,
} from "constants/ApiConstants";
import qs from "qs";

const adminApi = {
  signIn: () => axiosAdminInstance.post("oauth/admin/signIn"),
  getUserIdAPI: () => axiosAdminInstance.get(`oauth/info`),
  saveSession: () =>
    axiosAdminInstance.post(`accounts/userTracking/SaveSession`),
  closeSession: (sessionId) =>
    axiosAdminInstance.put(`accounts/userTracking/CloseSession/${sessionId}`),
  getOrganizationsListAPI: (searchKeys, cancelToken) =>
    axiosAdminInstance.get(`${ADMIN_URL}`, {
      params: {
        ...searchKeys,
      },
      cancelToken,
    }),
  getOrganizationAPI: (organizationId, cancelToken) =>
    axiosAdminInstance.get(`${ADMIN_URL}/${organizationId}`, { cancelToken }),
  getOrganizationUsersListAPI: (organizationId, searchKeys, cancelToken) =>
    axiosAdminInstance.get(`${ADMIN_URL}/${organizationId}/users`, {
      params: {
        ...searchKeys,
      },
      cancelToken,
    }),
  getOrganizationUsersInvitationsListAPI: (
    organizationId,
    searchKeys,
    cancelToken
  ) =>
    axiosAdminInstance.get(`${ADMIN_URL}/${organizationId}/users/invitations`, {
      params: { ...searchKeys },
      cancelToken,
    }),
  resendUserInvitationAPI: (organizationId, id) =>
    axiosAdminInstance.put(
      `${ADMIN_URL}/${organizationId}/users/invitation/${id}/resend`
    ),
  cancelUserInvitationAPI: (organizationId, id) =>
    axiosAdminInstance.put(
      `${ADMIN_URL}/${organizationId}/users/invitation/${id}/cancel`
    ),
  sendInvitation: (organizationId, data) =>
    axiosAdminInstance.post(
      `/${ADMIN_URL}/${organizationId}/users/invite`,
      data
    ),
  addOrganizationAPI: (data) => axiosAdminInstance.post(`${ADMIN_URL}`, data),
  sendUserInvitationAPI: (organizationId, data) =>
    axiosAdminInstance.post(
      `/${ADMIN_URL}/${organizationId}/users/invite`,
      data
    ),
  addAttachment: (file) => axiosAdminInstance.post("api/attachments", file),
  updateProfileContent: (data) => axiosAdminInstance.put(`${ADMIN_URL}`, data),
  getUsersList: (searchKeys, cancelToken) =>
    axiosAdminInstance.get(`${ADMIN_USER_URL}`, {
      params: {
        ...searchKeys,
      },
      cancelToken,
    }),
  getInvitationsList: (searchKeys, cancelToken) =>
    axiosAdminInstance.get(`${ADMIN_URL}/users/invitations`, {
      params: { ...searchKeys },
      cancelToken,
    }),
  getUserById: (id) => axiosAdminInstance.get(`admin/user/${id}`),
  moveUserOffersToOrg: (id) =>
    misbarAdminInstance.put(`admin/user/${id}/offers/moveToOrganization`),
  activateUser: (id) => axiosAdminInstance.put(`admin/user/${id}/activate`),
  deactivateUser: (id) => axiosAdminInstance.put(`admin/user/${id}/deactivate`),
  addSuperAdmin: (id) => axiosAdminInstance.put(`admin/user/${id}/addAdmin`),
  removeSuperAdmin: (id) =>
    axiosAdminInstance.delete(`admin/user/${id}/removeAdmin`),
  getTestUsers: (_, cancelToken) =>
    axiosAdminInstance.get(`${ADMIN_USER_URL}/testPhoneUsers`, { cancelToken }),
  createTestUser: (data) =>
    axiosAdminInstance.post(`${ADMIN_USER_URL}/testPhoneUser`, data),
  deleteTestUser: (phoneNumber) =>
    axiosAdminInstance.delete(
      `${ADMIN_USER_URL}/testPhoneUser?phoneNumber=${phoneNumber}`
    ),
  moveUsersToOrg: (userIds, organizationId, role) => {
    let initialText = "";
    userIds.forEach((id) => (initialText += `&userId=${id}`));
    return axiosAdminInstance.put(
      `${ADMIN_USER_URL}/moveToOrganization/${organizationId}?roleId=${role}${initialText}`
    );
  },
  moveOffersToOrg: (userIds) => {
    let initialText = "";
    userIds.forEach((id, index) =>
      index === 0
        ? (initialText += `userId=${id}`)
        : (initialText += `&userId=${id}`)
    );
    return misbarAdminInstance.put(
      `${ADMIN_USER_URL}/offers/moveToOrganization?${initialText}`
    );
  },
  assignUserRole: (id, organizationId, role) =>
    axiosAdminInstance.post(
      `${ADMIN_URL}/${organizationId}/user/${id}/role/${role}`
    ),
  removeUserRole: (id, organizationId, role) =>
    axiosAdminInstance.delete(
      `${ADMIN_URL}/${organizationId}/user/${id}/role/${role}`
    ),
  getAllOrganizations: () => axiosAdminInstance.get(`${ADMIN_URL}`),
  getAdminsList: (searchKeys, cancelToken) =>
    axiosAdminInstance.get(`${ADMIN_USER_URL}`, {
      params: { ...searchKeys },
      cancelToken,
    }),
  mergeUsers: (data) => axiosAdminInstance.put(`${ADMIN_USER_URL}/merge`, data),
  activateOrganizationUserAPI: (orgUserId) => {
    return axiosAdminInstance.put(`${ORG_USER_URL}/${orgUserId}/activate`);
  },
  deactivateOrganizationUserAPI: (orgUserId) => {
    return axiosAdminInstance.put(`${ORG_USER_URL}/${orgUserId}/deactivate`);
  },
  assignRoleToOrganizationUserAPI: (orgUserId, role) => {
    return axiosAdminInstance.post(`${ORG_USER_URL}/${orgUserId}/role/${role}`);
  },
  removeRoleToOrganizationUserAPI: (orgUserId, role) => {
    return axiosAdminInstance.delete(
      `${ORG_USER_URL}/${orgUserId}/role/${role}`
    );
  },
  removeOrganizationUserAPI: (orgUserId) => {
    return axiosAdminInstance.delete(`${ORG_USER_URL}/${orgUserId}`);
  },
  getOrgRoles: (orgId, cancelToken) => {
    return axiosAdminInstance.get(`org/usersRoles/${orgId}`, { cancelToken });
  },
  getRegistrationFormRequests: (
    isBroker,
    isComplete,
    searchKeys,
    cancelToken
  ) => {
    return misbarAdminInstance.get(`badges/GetRegistrationFormRequests`, {
      params: { isBroker, isComplete, ...searchKeys },
      cancelToken,
    });
  },
  getRegistrationFormRequestsExcelSheet: (isBroker, isComplete, searchKeys) => {
    return axiosAdminInstance.get(`CsvExport/ExportBadgesFormRequests`, {
      params: { isBroker, isComplete, ...searchKeys },
    });
  },
  approveRegistrationForm: (data) => {
    return misbarAdminInstance.put(`badges/ApproveRegistrationForm`, data);
  },
  rejectRegistrationForm: (data) => {
    return misbarAdminInstance.put(`badges/RejectRegistrationForm`, data);
  },
  getAllCustomNotifications: (params, cancelToken) => {
    return axiosAdminInstance.get(`GetAllCustomNotifications`, {
      params,
      cancelToken,
    });
  },
  postCustomNotification: (data) => {
    return axiosAdminInstance.post(`SendCustomNotification`, data);
  },
  deleteCustomNotification: (id) => {
    return axiosAdminInstance.delete(`DeleteCustomNotification/${id}`);
  },
  updateUserDate: (data) =>
    axiosAdminInstance.put(
      `${MARKETPLACE_URL}/BackOffice/user/UpdateUserProfileData`,
      data
    ),
  getComplaints: (searchKeys, cancelToken) =>
    axiosAdminInstance.get("complaints", {
      params: { ...searchKeys },
      cancelToken,
    }),
  getComplaintsExcelSheet: (searchKeys) =>
    axiosAdminInstance.get("CsvExport/ExportComplains", {
      params: { ...searchKeys },
    }),
  getUsersOffersList: (searchKeys, cancelToken) => {
    const params = {
      ...searchKeys,
    };
    return misbarAdminInstance.get(`admin/list`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
      cancelToken,
    });
  },
  deleteUserOffer: (params) =>
    misbarAdminInstance.delete(`${OFFER_URL}/admin/delete`, {
      params,
    }),
  getDeleteOfferReasons: () =>
    misbarAdminInstance.get(`${OFFER_URL}/offerRegaDeleteReason`),
  getRegionsData: () =>
    misbarAdminInstance.get(`${OFFER_URL}/GetAdminRegionTreeSearchFilter`),
  getOffersListExcelSheet: (searchKeys) =>
    axiosAdminInstance.get(`CsvExport/ExportAdminOffersList`, {
      params: { ...searchKeys },
    }),
  createComplaintNote: (data) =>
    axiosAdminInstance.post(`complaints/complaint/note`, data),
  updateComplaintNote: (data) =>
    axiosAdminInstance.put(`complaints/complaintId/note`, data),
};

export default adminApi;
